module.exports = __webpack_public_path__ + "static/media/voiceca5adfa1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/voice.svg
// module id = 1346
// module chunks = 0